import React from 'react';
import { Typography, theme } from 'antd';

const { Title } = Typography;

/** Quiet kicker + title used on patient detail (record + clinical forms). */
const SectionHeading = ({ kicker, title, extra, id, bordered = false, style }) => {
  const { token } = theme.useToken();
  const hasHeading = !!(kicker || title);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: hasHeading ? 'flex-end' : 'center',
        justifyContent: 'space-between',
        gap: 16,
        width: '100%',
        ...(bordered
          ? {
              marginBottom: 20,
              paddingBottom: 12,
              borderBottom: `1px solid ${token.colorBorderSecondary}`,
            }
          : null),
        ...style,
      }}
    >
      {hasHeading && (
        <div>
          {kicker && (
            <div
              style={{
                fontSize: 11,
                fontWeight: 500,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: token.colorTextTertiary,
                marginBottom: title ? 4 : 0,
              }}
            >
              {kicker}
            </div>
          )}
          {title && (
            <Title
              id={id}
              level={4}
              style={{
                margin: 0,
                fontWeight: 500,
                fontSize: 20,
                lineHeight: 1.3,
                color: token.colorText,
              }}
            >
              {title}
            </Title>
          )}
        </div>
      )}
      {extra ? <div style={{ flexShrink: 0, marginLeft: 'auto' }}>{extra}</div> : null}
    </div>
  );
};

export default SectionHeading;
